export default __webpack_public_path__ + "static/media/CONDIZIONI GENERALI D’APPALTO SI PER FORNITURE, LAVORI E SERVIZI A TERRA.a82e2b06.pdf";